module.exports = __webpack_public_path__ + "img/pauli-y-root-30.2bb99e5b.svg";